// extracted by mini-css-extract-plugin
export default {"phoneNumber":"Style_phoneNumber__ZIzPy","phoneCode":"Style_phoneCode__KUdQW","phone":"Style_phone__9uMRf","phoneCodeOption":"Style_phoneCodeOption__RhGpH"};